import { TextFieldModule } from '@angular/cdk/text-field';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslocoModule } from '@jsverse/transloco';
import { NgChartsModule } from 'ng2-charts';

import { ActionPopupComponent } from './components/action-popup/action-popup.component';
import { BarChartComponent } from './components/bar-chart/bar-chart.component';
import { CategoryBarChartComponent } from './components/category-bar-chart/category-bar-chart.component';
import { ChartHintComponent } from './components/chart-hint/chart-hint.component';
import { ChildAgeComponent } from './components/child-age/child-age.component';
import { EmojiRatingDisplayComponent } from './components/emoji-rating-display/emoji-rating-display.component';
import { EmojiRatingComponent } from './components/emoji-rating/emoji-rating.component';
import { HexagonComponent } from './components/hexagon/hexagon.component';
import { LanguagePickerComponent } from './components/language-picker/language-picker.component';
import { LockIconComponent } from './components/lock-icon/lock-icon.component';
import { PercentageComponent } from './components/percentage/percentage.component';
import { PrintDownloadIconComponent } from './components/print-download-icon/print-download-icon.component';
import { PlanLinkedActivitesComponent } from './components/plan-linked-activites/plan-linked-activites.component';
import { PortfolioLinkedTargetsComponent } from './components/portfolio-linked-targets/portfolio-linked-targets.component';
import { PortfolioPlanBaseItemComponent } from './components/portfolio-plan-base-item/portfolio-plan-base-item.component';
import { PortfolioPlanCompetenceComponent } from './components/portfolio-plan-competence/portfolio-plan-competence.component';
import { PortfolioPlanDescriptionComponent } from './components/portfolio-plan-description/portfolio-plan-description.component';
import { PortfolioPlanDocumentsComponent } from './components/portfolio-plan-documents/portfolio-plan-documents.component';
import { PortfolioPlanPlannedComponent } from './components/portfolio-plan-planned/portfolio-plan-planned.component';
import { PortfolioPlanSelfReflectionComponent } from './components/portfolio-plan-self-reflection/portfolio-plan-self-reflection.component';
import { ProgressChartComponent } from './components/progress-doughnut-chart/progress-doughnut-char.component';
import { RightSidebarPanelComponent } from './components/right-sidebar-panel/right-sidebar-panel.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { SimpleBadgeComponent } from './components/simple-badge/simple-badge.component';
import { SocialNetworksIconsComponent } from './components/social-networks-icons/social-networks-icons.component';
import { SortableComponent } from './components/sortable/sortable.component';
import { TabSwitchComponent } from './components/tab-switch/tab-switch.component';
import { ToastsComponent } from './components/toasts/toasts.component';
import TrackByPropertyDirective from './directives/track-by-property.directive';
import { CompetenceChipsPipe } from './pipes/competence-chips.pipe';
import { CompetenceNumberPipe } from './pipes/competence-number.pipe';
import { FileSizePipe } from './pipes/file-size.pipe';
import { SafePipe } from './pipes/safe.pipe';
import { WithLoaderPipe } from './pipes/with-loader.pipe';
import { TableProgressBarComponent } from './components/table-progress-bar/table-progress-bar.component';
import { AnnouncementComponent } from './components/announcement/announcement.component';
import { InfoPopupComponent } from './components/info-popup/info-popup.component';
import { RenameFileModalComponent } from './components/rename-file-modal/rename-file-modal.component';
import { DocumentPreviewComponent } from './components/document-preview/document-preview.component';

const COMPONENTS = [
  ChildAgeComponent,
  LanguagePickerComponent,
  LockIconComponent,
  SimpleBadgeComponent,
  SocialNetworksIconsComponent,
  ToastsComponent,
  TrackByPropertyDirective,
  WithLoaderPipe,
  SafePipe,
  CategoryBarChartComponent,
  HexagonComponent,
  ChartHintComponent,
  PercentageComponent,
  PrintDownloadIconComponent,
  FileSizePipe,
  CompetenceNumberPipe,
  CompetenceChipsPipe,
  SortableComponent,
  PortfolioPlanBaseItemComponent,
  PortfolioPlanDescriptionComponent,
  EmojiRatingDisplayComponent,
  EmojiRatingComponent,
  PortfolioPlanSelfReflectionComponent,
  PortfolioPlanCompetenceComponent,
  PortfolioPlanPlannedComponent,
  PortfolioLinkedTargetsComponent,
  PlanLinkedActivitesComponent,
  PortfolioPlanDocumentsComponent,
  ActionPopupComponent,
  RightSidebarPanelComponent,
  TabSwitchComponent,
  ProgressChartComponent,
  BarChartComponent,
  SidebarComponent,
  TableProgressBarComponent,
  AnnouncementComponent,
  InfoPopupComponent,
  RenameFileModalComponent,
  DocumentPreviewComponent,
];
@NgModule({
  imports: [CommonModule, ReactiveFormsModule, TranslocoModule, NgbModule, RouterModule, NgChartsModule, MatButtonModule, TextFieldModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS, TranslocoModule, NgChartsModule],
})
export class CoreUiModule {}
